import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import { useTranslation } from 'react-i18next';

import useGetTrapsActivityLineChart from 'hooks/Analitics/MCTCharts/2_trapsActivityLineChart/useGetTrapsActivityLineChart';
import { trapActivityLineChartOptions } from 'pages/ObjectAnalitics/MCTCharts/2trapActivityLineChart/chartOptions';
import { TrapType } from 'components/AnalyticsPage/TrapType';

interface Props {
  slug: string;
  trapType: TrapType;
  startDate: string;
  endDate: string;
  zoom?: boolean;
}

interface ChartData {
  date: string[];
  mct_count?: number[];
  smst_count?: number[];
  srst_count?: number[];
}

export const TrapTimeLineChart: React.FC<Props> = ({ slug, trapType, endDate, startDate, zoom = true }) => {
  const { data } = useGetTrapsActivityLineChart(slug, 'CUSTOM', trapType, startDate, endDate);
  const { t } = useTranslation();

  const [chartData, setChartData] = useState<ChartData>({
    date: [],
    mct_count: [],
    smst_count: [],
    srst_count: [],
  });

  useEffect(() => {
    if (data) {
      const date = data.map((item: any) => item.date);
      const mct_count = data.map((item: any) => item.mct_count);
      const smst_count = data.map((item: any) => item.smst_count);
      const srst_count = data.map((item: any) => item.srst_count);
      trapType === TrapType.MCT && setChartData({ date, mct_count });
      trapType === TrapType.SMST && setChartData({ date, smst_count });
      trapType === TrapType.SRST && setChartData({ date, srst_count });
    }
  }, [data, trapType]);

  const chartOptions = trapActivityLineChartOptions(
    chartData,
    t,
    false,
    trapType,
    false,
    'Mice captures in traps chart',
    zoom,
  );

  return (
    <div className="card-body">
      <div className="position-relative">
        <ReactApexChart key={trapType} options={chartOptions} series={chartOptions.series} type="area" height={350} />
      </div>
    </div>
  );
};
